import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { FullCenterContent } from '@shared/ui/wrappers'

import { Content } from './ui'

const FCError = () => {
  const { t } = useTranslation('titles')

  return (
    <>
      <title>{t('titles:genError')}</title>

      <FullCenterContent>
        <Content />
      </FullCenterContent>
    </>
  )
}

export const ErrorPage = memo(FCError)
